<template>
  <div>
    <v-tabs v-model="tab" fixed-tabs>
      <!-- <v-tabs-slider color="yellow"></v-tabs-slider> -->
      <v-tab>Loo uus konto</v-tab>
      <v-tab>
        <small>
          Sul on juba
          <br />
          Bookus.live konto?
        </small>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item class="mt-5">
        <RegisterForm @authenticated="$emit('authenticated')" hide-title :login-link="false" />
      </v-tab-item>
      <v-tab-item class="mt-5">
        <LoginForm @authenticated="$emit('authenticated')" hide-title :register-link="false" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";

export default {
  components: {
    RegisterForm,
    LoginForm,
  },
  data() {
    return {
      register: false,
      tab: null,
    };
  },
};
</script>

<style></style>
